module.exports = __webpack_public_path__ + "img/portalmanagement_onboarding.a6abd55e.png";